import React, { useState, useRef } from 'react';
import icon_menu_dots from 'images/icon_menu_dots.svg';
import 'antd/dist/antd.css';
import { Row, Col, Typography, Button, Modal, message } from 'antd';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { cloneDeep, set } from 'lodash';
import icon_rename from 'images/new_pop_ups/rename.svg';

import DeleteModal from 'components/content/newModal/DeleteModal';
import RenameModal from 'components/content/newModal/RenameModal';

import {
    deleteFile,
    changeFileName,
    downloadOriginalFile
} from 'services/home';

const FileDropdown = ({ row, dataTable, setDataTable, handleTableRender }) => {
    const ref = useRef();
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [isModalRename, setIsModalRename] = useState(false);
    const [currentFileId, setCurrentFileId] = useState();
    const [fileName, setFileName] = useState();
    const [isModalVisibleDeleteProject, setIsModalVisibleDeleteProject] =
        useState(false);

    useOnClickOutside(ref, () => setDropdownVisible(false));

    const handleOpen = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleDatasetRename = (data) => {
        setCurrentFileId(data.id);
        setFileName(data.name);
        setIsModalRename(true);
    };

    const handleDatasetDelete = (data) => {
        setCurrentFileId(data.id);

        setIsModalVisibleDeleteProject(true);
    };

    const handleFileName = (e) => {
        setFileName(e.target.value);
    };

    const handleCancelRename = () => {
        setIsModalRename(false);
    };

    const handleOkRename = () => {
        changeFileName(currentFileId, fileName).then((res) => {
            if (res.status == 200) {
                let cloneDataTable = cloneDeep(dataTable);

                let fileIndex = cloneDataTable
                    .map((x) => {
                        return x.id;
                    })
                    .indexOf(currentFileId);

                cloneDataTable[fileIndex]['name'] = fileName;
                setDataTable(cloneDataTable);

                setIsModalRename(false);
                handleTableRender();
            }
        });

        // deleteFileById();
        // deleteFile();
    };

    const handleDownloadOriginalFile = (fileId, fileName) => {
        downloadOriginalFile(fileId, fileName);
        handleTableRender();
    };

    const handleOkDeleteProject = () => {
        setIsModalVisibleDeleteProject(false);
        // deleteFileById(idProjectToRemove);
        deleteFile(currentFileId).then((res) => {
            if (res.status == 204) {
                handleTableRender();
            }
        });
    };

    const handleCancelDeleteProject = () => {
        setIsModalVisibleDeleteProject(false);
    };

    return (
        <>
            <div
                className="dropdown flex-center"
                onClick={handleOpen}
                ref={ref}
            >
                <Button
                    style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }}
                    shape="circle"
                >
                    <img src={icon_menu_dots} className="icon-menu-dots-svg" />
                </Button>
                {dropdownVisible && (
                    <div
                        className={
                            dropdownVisible
                                ? 'dropdown-content-visible'
                                : 'dropdown-content-invisible'
                        }
                    >
                        <button
                            onClick={(e) => {
                                handleDatasetRename(row);
                            }}
                            className="button-dropdown"
                        >
                            Rename Dataset
                        </button>
                        <button
                            onClick={() => {
                                handleDownloadOriginalFile(
                                    row.id,
                                    row.file_name
                                );
                            }}
                            className="button-dropdown"
                        >
                            Download Original File
                        </button>
                        <button
                            className="button-dropdown"
                            onClick={() => {
                                handleDatasetDelete(row);
                            }}
                        >
                            Delete Dataset
                        </button>
                    </div>
                )}
            </div>

            <DeleteModal
                visible={isModalVisibleDeleteProject}
                onAccept={handleOkDeleteProject}
                onCancel={handleCancelDeleteProject}
                modalType="deleteDataset"
            />

            <RenameModal
                visible={isModalRename}
                onAccept={handleOkRename}
                onCancel={handleCancelRename}
                handleNewRename={handleFileName}
                currentName={fileName}
                modalType="renameFile"
            />
        </>
    );
};

export default FileDropdown;
